module.exports = __webpack_public_path__ + "static/media/678JettStNW_2018-06-26_193.93384a1a.jpg";